import { Input } from "@repo/ui/Inputs/input";
import { Textarea } from "@repo/ui/Inputs/textarea";
import type { FC } from "react";
import { SharedToolFormFields } from "./sharedToolFormFields.js";

interface CallTransferToolFormProps {
  name: string;
  description: string;
  settings: CallTransferToolFormSettings;
  onNameChange: (name: string) => void;
  onDescriptionChange: (description: string) => void;
  onSettingsChange: (settings: Partial<CallTransferToolFormSettings>) => void;
}

export interface CallTransferToolFormSettings {
  destination: string;
  timeoutSeconds: string;
  timeoutSecondsError: string | undefined;
  sipHeaders: string;
  sipHeadersError: string | undefined;
}

export const CallTransferToolForm: FC<CallTransferToolFormProps> = ({
  name,
  description,
  settings,
  onNameChange,
  onDescriptionChange,
  onSettingsChange,
}) => {
  return (
    <div className="grid grid-cols-2 gap-4">
      <SharedToolFormFields
        name={name}
        description={description}
        onNameChange={onNameChange}
        onDescriptionChange={onDescriptionChange}
        namePlaceholder="Transfer to human agent"
        descriptionPlaceholder="Connects the caller to a human agent support line. Use this when the caller requests to speak to a human agent or needs help that requires human assistance."
      />

      <div>
        <Input
          id="destination"
          label="Destination"
          value={settings.destination}
          onChange={(e) => onSettingsChange({ destination: e.target.value })}
          placeholder="+15551234567 or sip:support@company.com"
          maxLength={100}
        />
      </div>

      <div>
        <Input
          id="timeoutSeconds"
          label="Timeout (seconds)"
          value={settings.timeoutSeconds}
          onChange={(e) =>
            onSettingsChange({
              timeoutSeconds: e.target.value,
              timeoutSecondsError: undefined,
            })
          }
          placeholder="30"
          errorDescription={settings.timeoutSecondsError}
          maxLength={100}
        />
      </div>

      <div className="col-span-full">
        <Textarea
          id="sipHeaders"
          label="SIP Headers (JSON)"
          value={settings.sipHeaders}
          onChange={(value) =>
            onSettingsChange({ sipHeaders: value, sipHeadersError: undefined })
          }
          placeholder='{"X-Custom-Header": "value"}'
          errorDescription={settings.sipHeadersError}
        />
      </div>
    </div>
  );
};
